module.exports = __webpack_public_path__ + "ClientApp/images/content/mobile/Lap-of-love-veterinary-care-coordinator.jpg";